import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';

import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    standalone: false
})
export class SigninComponent {

    constructor(private authService: AuthService, private router: Router) { }

    onSignin(form: NgForm) {
        const username = form.value.username;
        const password = form.value.password;
        this.authService.signinUser(username, password).subscribe(
            (response) => {
                if (this.authService.redirectUrl) {
                    this.router.navigateByUrl(this.authService.redirectUrl);
                    this.authService.redirectUrl = null;
                } else {
                    this.router.navigate(['/']);
                }
            }
        );


    }

}
